module.exports = __webpack_public_path__ + "static/media/Portrait-10051.9004cd53.jpg";